<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <!-- Site wrapper -->
    <div class="wrapper">
        <!-- Navbar -->
        <app-header></app-header>
        <!-- /.navbar -->

        <!-- Main Sidebar Container -->
        <app-sidebar [page]="'settings'" [subPage]="'administrator'"></app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">Settings</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item"><a href="#">Settings</a></li>
                            <li class="breadcrumb-item active">Administrators</li>
                        </ol>
                    </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->

            <!-- Main content -->
            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'settings'" [activeSlug]="'administrator'"></app-module-menu>
                    <div class="row">
                        <div class="col-md-3 d-none" *ngIf="viewOne">
                            <div class="sticky-top mb-3">
                                <!-- Profile Image -->
                                <div class="card card-primary card-outline">
                                    <div class="card-body box-profile">
                                        <div class="text-center">
                                            <img class="profile-user-img img-fluid img-circle" src="https://ui-avatars.com/api/?name={{oneAdmin.nickName}}&background=0D8ABC&color=fff" alt="{{oneAdmin.nickName}}">
                                        </div>
                                        <h3 class="profile-username text-center">{{oneAdmin.firstName + " " + oneAdmin.lastName}}</h3>
                                        <p class="text-muted text-center">{{oneAdmin.username}}</p>

                                        <ul class="list-group list-group-unbordered mb-3">
                                            <li class="list-group-item">
                                                <b>E-Mail</b> <a class="float-right">{{oneAdmin.email}}</a>
                                            </li>
                                            <li class="list-group-item">
                                                <b>Status</b> <a class="float-right">
                                                    <span [class]="
                                                    oneAdmin.accountStatus.newAccount === true ? 'badge bg-info' : 
                                                    oneAdmin.accountStatus.inactiveAccount === true ? 'badge bg-warning' : 
                                                    oneAdmin.accountStatus.activeAccount === true ? 'badge bg-success' : 
                                                        'badge bg-danger'" [innerHTML]="
                                                        oneAdmin.accountStatus.newAccount === true ? 'New' : 
                                                        oneAdmin.accountStatus.inactiveAccount === true ? 'Pending' : 
                                                        oneAdmin.accountStatus.activeAccount === true ? 'Active' : 
                                                        'Password Change'">
                                                    </span>
                                                </a>
                                            </li>
                                            <li class="list-group-item">
                                                <b>Permission</b> <a class="float-right">{{oneAdmin.rights.adminType}}</a>
                                            </li>
                                            <li class="list-group-item">
                                                <b>Network</b> <a class="float-right"><span *ngFor="let countryList of oneAdmin.rights.countryList;">
                                                    <span class="badge bg-primary">{{countryList}}</span>&nbsp;
                                                </span></a>
                                            </li>
                                            <li class="list-group-item">
                                                <b>Created</b> <a class="float-right">{{oneAdmin.created}}</a>
                                            </li>
                                            <li class="list-group-item">
                                                <b>Last Modified</b> <a class="float-right">{{oneAdmin.lastModified}}</a>
                                            </li>
                                        </ul>
                                        <button type="button" class="btn btn-primary btn-block" *ngIf="!hasStaffProfile(oneAdmin) && checkService.canWrite('administrators')" [disabled]="processing" (click)="createStaffFromAdmin(oneAdmin)">Create Staff Profile</button>
                                    </div>
                                    <!-- /.card-body -->
                                </div>
                                <!-- /.card -->
                            </div>
                        </div>
                        <div class="modal fade" id="modal-admin-form" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite('administrators') || checkService.canModify('administrators')">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                <div class="card card-primary card-outline mb-0">
                                    <div class="card-header">
                                        <h4 class="card-title">{{formHeader}}</h4>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="onCancel()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <!-- form start -->
                                    <form [formGroup]="dataForm">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label for="lname">Last Name</label>
                                                <input type="text" required [ngClass]="(lname.invalid && (lname.dirty || lname.touched)) ? 'form-control is-invalid' : (lname.valid)? 'form-control is-valid':'form-control'" formControlName="lname" id="lname" placeholder="Full Names">
                                                <div *ngIf="lname.invalid && (lname.dirty || lname.touched)" class="invalid-feedback">
                                                    <div *ngIf="lname.errors.required">Last name is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="fname">First Name</label>
                                                <input type="text" required [ngClass]="(fname.invalid && (fname.dirty || fname.touched)) ? 'form-control is-invalid' : (fname.valid)? 'form-control is-valid':'form-control'" formControlName="fname" id="fname" placeholder="First Name">
                                                <div *ngIf="fname.invalid && (fname.dirty || fname.touched)" class="invalid-feedback">
                                                    <div *ngIf="fname.errors.required">FIrst Name is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="email">E-Mail</label>
                                                <input type="email" required [ngClass]="(email.invalid && (email.dirty || email.touched)) ? 'form-control is-invalid' : (email.valid)? 'form-control is-valid':'form-control'" formControlName="email" id="email" placeholder="E-Mail">
                                                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
                                                    <div *ngIf="email.errors.required">E-Mail is required</div>
                                                </div>
                                            </div>
                                            
                                            <div class="form-group">
                                                <label for="adminType">Roles and Permission</label>
                                                <select required [ngClass]="(adminType.invalid && (adminType.dirty || adminType.touched)) ? 'form-control is-invalid' : (adminType.valid)? 'form-control is-valid':'form-control'" formControlName="adminType" id="adminType">
                                                    <option value="">Select One</option>
                                                    <option *ngFor="let adminRightRow of adminRightList;" value="{{adminRightRow.ref}}">{{adminRightRow.adminType}}</option>
                                                </select>
                                                <div *ngIf="adminType.invalid && (adminType.dirty || adminType.touched)" class="invalid-feedback">
                                                    <div *ngIf="adminType.errors.required">Roles and Permission is required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /.card-body -->

                                        <div class="card-footer">
                                            <input type="hidden" formControlName="ref" id="ref">
                                            <button type="submit" [disabled]="!dataForm.valid || dataForm.pending || processing" (click)="onCreate()" class="btn btn-primary">{{buttonText}}</button>&nbsp;
                                            <button type="button" data-dismiss="modal" (click)="onCancel()" class="btn btn-default">Cancel</button>
                                        </div>
                                    </form>
                                <!-- /.card-body -->
                                </div>
                            </div>
                        </div>
                        </div>
                        <!-- /.col -->
                        <div [ngClass]="viewOne ? 'col-md-9' : 'col-md-12'">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/LoadingGIF/Rolling-1s-75px.gif">

                                <!-- Default box -->
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-edit"></i>
                                            {{mainHeader}}
                                        </h3>
                                        <div class="text-right"> 
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-primary btn-sm" *ngIf="checkService.canWrite('administrators')" data-toggle="modal" data-target="#modal-admin-form" (click)="onCancel()">
                                                    <i class="fas fa-plus"></i> Add Administrator
                                                </button>&nbsp;
                                                <a [routerLink]="['/settings/administrator']" class="btn btn-primary btn-sm" type="button">All</a>&nbsp;
                                                <a [routerLink]="['/settings/administrator/active']" class="btn btn-primary btn-sm" type="button">Active</a>&nbsp;
                                                <a [routerLink]="['/settings/administrator/inactive']" class="btn btn-primary btn-sm" type="button">In-Active</a>&nbsp;
                                                <a [routerLink]="['/settings/administrator/new']" class="btn btn-primary btn-sm" type="button">New Account</a>&nbsp;
                                                <a [routerLink]="['/settings/administrator/newPassword']" class="btn btn-primary btn-sm" type="button">Password Pending</a>&nbsp;
                                                
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" placeholder="Search Mail">
                                                </div>
                                                <button [routerLink]="['/adverts/Deleted']" class="btn btn-primary btn-sm" type="button"><i class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Username</th>
                                                    <th>Full Names</th>
                                                    <th>E-Mail</th>
                                                    <th>Status</th>
                                                    <th>Creation Date</th>
                                                    <th>Modified Last</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let adminRow of adminList;">
                                                    <td>{{adminRow.username}}</td>
                                                    <td><i *ngIf="userData.ref == adminRow.ref" class="fas fa-user"></i>{{adminRow.firstName + " " + adminRow.lastName}}</td>
                                                    <td>{{adminRow.email}}</td>
                                                    <td><span [class]="adminRow.accountStatus.activeAccount === true ? 'badge bg-success' : adminRow.accountStatus.newAccount === true ? 'badge bg-info' : adminRow.accountStatus.inactiveAccount === true ? 'badge bg-warning' : 'badge bg-danger'" [innerHTML]="adminRow.accountStatus.activeAccount === true ? 'Active' : adminRow.accountStatus.newAccount === true ? 'New' : adminRow.accountStatus.inactiveAccount === true ? 'Inactive' : 'Password Change'"></span></td>
                                                    <td>{{adminRow.created}}</td>
                                                    <td>{{adminRow.lastModified}}</td>
                                                    <td>
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" *ngIf="userData.ref != adminRow.ref && checkService.canModify('administrators')" title="Modify" data-toggle="modal" data-target="#modal-admin-form" (click)="getEdit(adminRow)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-secondary" *ngIf="userData.ref != adminRow.ref && checkService.canModify('administrators')" title="Reset Password" data-toggle="modal" data-target="#modal-reset" (click)="getDataFromList(adminRow.nickName, adminRow.ref)">
                                                                <i class="fas fa-key"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-secondary" *ngIf="userData.ref != adminRow.ref" title="View Details" (click)="viewAdmin(adminRow)">
                                                                <i class="fas fa-list"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-secondary" *ngIf="userData.ref == adminRow.ref" title="View Details" (click)="viewAdmin(adminRow)">
                                                                <i class="fas fa-list"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-primary" *ngIf="!hasStaffProfile(adminRow) && checkService.canWrite('administrators')" title="Create Staff Profile" (click)="createStaffFromAdmin(adminRow)">
                                                                <i class="fas fa-user-plus"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-success" *ngIf="userData.ref != adminRow.ref && checkService.canModify('administrators')" [hidden]="adminRow.accountStatus.newAccount === true || adminRow.accountStatus.passwordChange === true || adminRow.accountStatus.activeAccount === true" title="Activate" data-toggle="modal" data-target="#modal-activate" (click)="getDataFromList(adminRow.nickName, adminRow.ref)">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-warning" *ngIf="userData.ref != adminRow.ref && checkService.canModify('administrators')" [hidden]="adminRow.accountStatus.newAccount === true || adminRow.accountStatus.passwordChange === true || adminRow.accountStatus.inactiveAccount === true" title="Deactivate" data-toggle="modal" data-target="#modal-deactivate" (click)="getDataFromList(adminRow.nickName, adminRow.ref)">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" *ngIf="userData.ref != adminRow.ref && checkService.canModify('administrators')" title="Delete" data-toggle="modal" data-target="#modal-delete" (click)="getDataFromList((adminRow.nickName), adminRow.ref)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="adminList.length == 0">
                                                    <td colspan="7" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Username</th>
                                                    <th>Full Names</th>
                                                    <th>E-Mail</th>
                                                    <th>Status</th>
                                                    <th>Creation Date</th>
                                                    <th>Modified Last</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <!-- /.card-body -->
                                    <div class="card-footer" *ngIf="adminList.length > 0">
                                        <app-pagination [url]='url' [counts]='count'(refresh)="listAdministrator($event)"></app-pagination>
                                    </div>
                                    <!-- /.card-footer -->
                                </div>
                            </div>
                        <!-- /.card -->
                        </div>
                        <!-- /.col -->
                    </div>
                <!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content -->
            <!-- /.content-wrapper -->

        </div>
        <!-- /.content-wrapper -->
        <div class="side-drawer-backdrop" *ngIf="viewOne" (click)="closeAdminDrawer()"></div>
        <aside class="side-drawer" *ngIf="viewOne && oneAdmin">
            <div class="side-drawer-header">
                <div class="drawer-avatar">
                    <img src="https://ui-avatars.com/api/?name={{oneAdmin.nickName}}&background=073331&color=fff" alt="{{oneAdmin.nickName}}">
                </div>
                <div class="drawer-title">
                    <h3>{{oneAdmin.firstName + " " + oneAdmin.lastName}}</h3>
                    <p>{{oneAdmin.username}} &middot; {{oneAdmin.rights.adminType}}</p>
                </div>
                <span class="drawer-status" [ngClass]="oneAdmin.accountStatus.inactiveAccount === true ? 'status-warning' : ''">
                    <i class="fas fa-circle"></i>
                    {{ oneAdmin.accountStatus.newAccount === true ? 'new' : oneAdmin.accountStatus.inactiveAccount === true ? 'inactive' : oneAdmin.accountStatus.activeAccount === true ? 'active' : 'password change' }}
                </span>
                <button type="button" class="drawer-close" aria-label="Close details" (click)="closeAdminDrawer()"><i class="fas fa-times"></i></button>
            </div>
            <div class="drawer-tabs">
                <button type="button" class="active">Overview</button>
            </div>
            <div class="side-drawer-body">
                <div class="drawer-grid">
                    <div class="drawer-field"><span>Email</span><strong>{{oneAdmin.email}}</strong></div>
                    <div class="drawer-field"><span>Permission</span><strong>{{oneAdmin.rights.adminType}}</strong></div>
                    <div class="drawer-field"><span>Username</span><strong>{{oneAdmin.username}}</strong></div>
                    <div class="drawer-field"><span>Staff Profile</span><strong>{{hasStaffProfile(oneAdmin) ? 'Linked' : 'Not linked'}}</strong></div>
                    <div class="drawer-field drawer-field-wide">
                        <span>Network</span>
                        <strong><span class="badge bg-primary mr-1" *ngFor="let countryList of oneAdmin.rights.countryList;">{{countryList}}</span></strong>
                    </div>
                    <div class="drawer-field"><span>Created</span><strong>{{oneAdmin.created}}</strong></div>
                    <div class="drawer-field"><span>Last Modified</span><strong>{{oneAdmin.lastModified}}</strong></div>
                </div>
                <div class="mt-4" *ngIf="!hasStaffProfile(oneAdmin) && checkService.canWrite('administrators')">
                    <button type="button" class="btn btn-primary" [disabled]="processing" (click)="createStaffFromAdmin(oneAdmin)">Create Staff Profile</button>
                </div>
            </div>
        </aside>
        <app-footer></app-footer>
    </div>
    <!-- ./wrapper -->
</div>

<div class="modal fade" id="modal-activate">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Activate Administrator</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will activate '+adminName+'. Are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" (click)="changeAdminStatus('activate', adminRef)" class="btn btn-outline-light">Activate Administrator</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-deactivate">
      <div class="modal-dialog">
        <div class="modal-content bg-secondary">
          <div class="modal-header">
            <h4 class="modal-title">Deactivate Administrator</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p [innerHTML]="'This action will deactivate '+adminName+'. Are you sure you want to continue ?'"></p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
            <button type="button" (click)="changeAdminStatus('deactivate', adminRef)" class="btn btn-outline-light">Deactivate Administrator</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-delete">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Delete Administrator</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will remove '+adminName+'. This action is not reversable, are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-outline-light" (click)="deleteAdmin(adminRef)">Delete Administrator</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-reset">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Reset Administrator Password</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will reset the password associated with the account belonging to '+adminName+'. Are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-outline-light" (click)="resetAdminPassword(adminRef)">Reset Password</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
